import { Component, EventEmitter, Input, OnInit } from '@angular/core';

@Component({
  selector: 'produto-page-fotos',
  templateUrl: './produto-page-fotos.component.html',
  styleUrls: ['./produto-page-fotos.component.scss']
})
export class ProdutoPageFotosComponent implements OnInit {

  @Input("fotos") photos:any = [];
  @Input("produto") product = null;
  public _openGallery     = new EventEmitter();

  public photo = [{
    image: "/images/sem-foto/default.jpg",
    title: "Próximo Passeio"
  },{
    image: "/images/sem-foto/default.jpg", 
    title: "Próximo Passeio"
  },{
    image: "/images/sem-foto/default.jpg",
    title: "Próximo Passeio"
  },{
    image: "/images/sem-foto/default.jpg",
    title: "Próximo Passeio"
  },{
    image: "/images/sem-foto/default.jpg",
    title: "Próximo Passeio"    
  }];

  public photoSpotlight = {
    image: "/images/sem-foto/default.jpg", 
    title: "Próximo Passeio"
  };

  constructor(){}

  /***
   * 
   * Open gallery
   * 
   */
  openGallery(){

    this._openGallery.emit();

  }
  /**
   * 
   * Set photos
   * 
   */
  setPhotos(){

    for (let index = 0; index < this.photos.length; index++) {

      this.photo[index] = {
        image: this.photos[index].imagem,
        title: this.photos[index].titulo 
      }

      if(this.photos[index].capa){

        this.photoSpotlight = {
          image: this.photos[index].imagem,
          title: this.photos[index].titulo 
        }

      }
      
    }

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{
    this.setPhotos();  
  }

}
